<img
    class="profile-picture"
    [defaultImage]="defaultImage"
    [ngClass]="{ shadow: shadow }"
    [authenticatedSrc]="profilePictureUrl"
    [ngStyle]="style"
    alt="Profile"
/>
